import { useMutation, useQueryClient } from "@tanstack/react-query";
import { bulkSendInvoices } from "@/api/v1-jwt/invoice/invoice";
import { useAuth } from "@/providers/auth";

export const useBulkSend = () => {
  const { cognitoId, clientId, userRole } = useAuth();
  const queryClient = useQueryClient();

  const userId =
    userRole === "admin" || userRole === "auth_user" ? clientId : cognitoId;

  return useMutation({
    mutationFn: (invoices) => bulkSendInvoices(userId, invoices),
    onSuccess: () => queryClient.invalidateQueries(["invoices"]),
  });
};
